import React, { useContext } from 'react';
import styled from 'styled-components';
import { FaStar } from 'react-icons/fa';
import { AppContext } from '../../context/AppContext';

const UpsellSection = styled.div`
  margin-top: 30px;
  border-top: 1px solid ${({ theme }) => theme.colors.lightGray};
  padding-top: 30px;
`;

const UpsellOption = styled.label`
  display: flex;
  gap: 15px;
  padding: 15px;
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  border-radius: ${({ theme }) => theme.radii.sm};
  margin-bottom: 15px;
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.fast};

  &:hover {
    border-color: ${({ theme }) => theme.colors.primaryLight};
    background: rgba(108, 92, 231, 0.05);
  }

  &.selected {
    border-color: ${({ theme }) => theme.colors.primary};
    background: rgba(108, 92, 231, 0.1);
  }

  input {
    margin-top: 3px;
    accent-color: ${({ theme }) => theme.colors.primary};
    width: 18px;
    height: 18px;
  }
`;

const UpsellContent = styled.div`
  flex: 1;
  h4 {
    font-size: 16px;
    margin-bottom: 5px;
  }
  p {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.gray};
    margin-bottom: 10px;
  }
  .price {
    font-weight: 700;
    color: ${({ theme }) => theme.colors.primaryDark};
  }
`;

const Title = styled.h3`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.primaryDark};
  margin-bottom: 18px;
`;

const UpsellComponent = ({ title, data }) => {
  const { cart, addToCart, removeFromCart } = useContext(AppContext);

  const handleToggleUpsell = (option, isChecked) => {
    if (isChecked) {
      addToCart({
        id: option.ID,
        title: option.title || 'Item Extra',
        price: Number(option.preco_venda) || 0
      });
    } else {
      removeFromCart(option.ID);
    }
  };

  return (
    <UpsellSection>
      <Title><FaStar /> {title}</Title>
      {data.map(option => {
        const isSelected = cart.some(item => item.id === option.ID);
        return (
          <UpsellOption
            key={option.ID || option.title || Math.random()}
            className={isSelected ? 'selected' : ''}
          >
            <input
              type="checkbox"
              checked={isSelected}
              onChange={e => handleToggleUpsell(option, e.target.checked)}
            />
            <UpsellContent>
              <h4>{option.title}</h4>
              {option.description && <p>{option.description}</p>}
              <span className="price">
                + R$ {Number(option.preco_venda).toFixed(2).replace('.', ',')}
              </span>
            </UpsellContent>
          </UpsellOption>
        );
      })}
    </UpsellSection>
  );
};

export default UpsellComponent;
